import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import styled from "styled-components";

const Container = styled.a`
  position: fixed;
  bottom: 25px;
  right: 25px;
  background: rgba(106, 104, 104, 0.13);
  border-radius: 16px;
  z-index: 10;
  backdrop-filter: blur(10.2px);
  -webkit-backdrop-filter: blur(10.2px);
  display: flex;
  border-radius: 50%;
  padding: 15px;
  cursor: pointer;
  font-size: 40px;
  @media (max-width: 576px) {
    right: 15px;
    bottom: 20px;
  }
`;

const CarButton = styled.a`
  background-color: ${(props) => (props.inverted ? "var(--red)" : "inherit")};
  font-size: 16px;
  border: 1px solid var(--red);
  border-radius: 20px;
  text-decoration: none;
  color: ${(props) => (props.inverted ? "var(--white)" : "var(--red)")};
  font-family: var(--roboto);
  width: 180px;
  height: 40px;
  cursor: pointer;
  transition: all 0.2s ease-out;
  font-weight: 500;
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  margin-top: 15px;

  @media screen and (min-width: 1000px) {
    &:hover {
      transition: all 0.2s ease-in;
      background-color: ${(props) =>
        props.inverted ? "#d00000" : "var(--red)"};
      border: 1px solid "#d00000";
    }
  }
`;

export const mensaje =
  `Hola, estoy interesado en el alquiler de un auto, quisiera saber si tienen disponibilidad para la fecha...`
    .split(" ")
    .join("%20");

const WhatsappBTN = () => {
  return (
    <Container
      href={`https://api.whatsapp.com/send?phone=5491130710101&text=${mensaje}`}
      target={"_blank"}
    >
      <FontAwesomeIcon icon={faWhatsapp} color={"#32cd32"} />
    </Container>
  );
};

export const CarWhatsappBtn = ({ msg }) => {
  return (
    <CarButton href={msg} target={"_blank"} inverted>
      <FontAwesomeIcon icon={faWhatsapp} color={"white"} />
      Estoy interesado/a
    </CarButton>
  );
};

export default WhatsappBTN;
